import Axios, { AxiosResponse } from "axios";
import GlobalConfig from "@/GlobalConfig";
import CryptoJS from "crypto-js";
import SoterService from "./soterService";
import { VBModal } from "bootstrap-vue";

export default class BaseService<T> {
  public apiUrl: string;

  public constructor(controllerName: string) {
    this.apiUrl = GlobalConfig.API_URL + controllerName + "/";
  }

  encryptByDES(message) {
    var soter = new SoterService();
    var r = soter.listJ();
    const k = CryptoJS.enc.Utf8.parse(r.l);
    const v = CryptoJS.enc.Utf8.parse(r.v);
    const encrypted = CryptoJS.AES.encrypt(message, k, {
      iv: v,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    var str = encrypted.toString();
    return str;
  }

  public async post(
    action: string,
    body: T,
    files?: {}
  ): Promise<AxiosResponse<any>> {
    let headers = {
      "Content-Type": "application/json",
    };
    if (files) {
      const formData = new FormData();
      for (const key in body) {
        if (body.hasOwnProperty(key)) {
          formData.append(key, JSON.stringify(body[key]));
        }
      }

      for (const key in files) {
        if (files.hasOwnProperty(key) && Array.isArray(files[key])) {
          files[key].forEach((file: File, i: number) => {
            formData.append(`${key}[${i}]`, file);
          });
        } else {
          console.error("Files object property is not an array of files");
        }
      }

      headers = {
        "Content-Type": "multipart/form-data",
      };
      (body as any) = formData;
      //acá desencriptar las respuestas de los post.
      var result = await Axios.post(this.apiUrl + action, body, {
        headers: headers,
      });
      var value = this.decryptByDES(result.data.val);
      result.data = JSON.parse(value);
      return new Promise<AxiosResponse<any>>((resolve, reject) => {
        resolve(result);
      });
    } else {
      var encriptmessage = this.encryptByDES(JSON.stringify(body));
      var result = await Axios.post(
        this.apiUrl + action,
        { value: encriptmessage },
        {
          headers: headers,
        }
      );

      var value = this.decryptByDES(result.data.val);
      result.data = JSON.parse(value);

      return new Promise<AxiosResponse<any>>((resolve, reject) => {
        resolve(result);
      });
    }
  }
  public decryptByDES(ciphertext) {
    var soter = new SoterService();
    var r = soter.listJ();
    const k = CryptoJS.enc.Utf8.parse(r.l);
    const v = CryptoJS.enc.Utf8.parse(r.v);
    var desc = CryptoJS.AES.decrypt(ciphertext, k, {
      iv: v,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    var hexDescrypt = desc.toString(CryptoJS.enc.Hex);
    var str = this.hex_to_ascii(hexDescrypt).replace(
      /[\x00-\x1F\x7F-\xA0]+/g,
      ""
    );

    return str;
  }

  hex_to_ascii(str1) {
    var hex = str1.toString();
    var str = "";
    for (var n = 0; n < hex.length; n += 2) {
      str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
  }

  public async get(
    controller: string,
    queryParams?: T
  ): Promise<AxiosResponse<any>> {
    let headers = {
      "Content-Type": "application/json",
    };
    var result = await Axios.get(this.apiUrl + controller, {
      params: { queryParams },
      headers: headers,
    });

    var value = this.decryptByDES(result.data.val);
    result.data = JSON.parse(value);

    return new Promise<AxiosResponse<any>>((resolve, reject) => {
      resolve(result);
    });
  }
}
